import { render, staticRenderFns } from "./ExtratoUtilizacaoUnimed.vue?vue&type=template&id=69994214&scoped=true&"
import script from "./ExtratoUtilizacaoUnimed.vue?vue&type=script&lang=js&"
export * from "./ExtratoUtilizacaoUnimed.vue?vue&type=script&lang=js&"
import style0 from "./ExtratoUtilizacaoUnimed.vue?vue&type=style&index=0&id=69994214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69994214",
  null
  
)

export default component.exports